import { ProjectStatus } from "@prisma/client";
import { JsonValue } from "@prisma/client/runtime/library";

function pathError(asset: "audio" | "image" | "video") {
  return `The ${asset}_file_path value provided does not point to a valid ${asset} file. This value should be a valid URL or file_path from the API https://docs.magichour.ai/api-reference/files/generate-asset-upload-urls.`;
}
const defaultError =
  "An unknown error occurred. Please try again or reach out to our support for assistance.";
export const errorMessage: Record<string, string> = {
  too_many_faces: "Please use an image with a single person",
  no_source_face: "Please use an image with a detectable face",
  nsfw: "It appears your content may include sensitive material and cannot be processed. Please review your content, make the necessary adjustments, and try again.",
  invalid_audio_file: "The audio file contains invalid data. Please try a different file.",
  invalid_video_file: "The video file contains invalid data. Please try a different file.",
  invalid_image_file: "The image file contains invalid data. Please try a different file.",
  invalid_audio_path: pathError("audio"),
  invalid_video_path: pathError("video"),
  invalid_image_path: pathError("image"),
  invalid_youtube_url:
    "The youtube video cannot be downloaded. The video may be private, age-restricted, or region-restricted. Please try a different url.",
  unknown_error: defaultError,

  // virtual try on errors
  no_model_detected: "Please use a image with a detectable model.",
  no_outfit_detected: "Please use an image with a detectable outfit.",
};

export function computeErrorObject(
  status: ProjectStatus,
  text: JsonValue
): { code: string; message: string } | null {
  if (status !== "ERROR") return null;

  if (typeof text !== "string") {
    return {
      code: "unknown_error",
      message: errorMessage.unknown_error || defaultError,
    };
  }

  const formatted = text.replaceAll("-", "_");

  if (errorMessage[formatted]) {
    return {
      code: formatted,
      message: errorMessage[formatted],
    };
  }

  // t2v and i2v errors
  if (formatted === "sensitive_image" || formatted === "sensitive_prompt") {
    return {
      code: "nsfw",
      message: errorMessage.nsfw || defaultError,
    };
  }

  return {
    code: "unknown_error",
    message: errorMessage.unknown_error || defaultError,
  };
}
